import React, { useEffect, useState } from "preact/compat";
import { CloseOutlined } from "@ant-design/icons";
import constants from "../constants";

export interface Props {
  open: boolean;
  onClose: () => void;
}

export default function AIPromoBanner({ open, onClose }: Props) {
  return (
    open && <div className="ai-promo-banner">
      <div className="banner-content">
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#magic-stars"}/>
        </svg>
        <span>
          Try our new AI Menu Copilot beta! <i>Includes spell check tool.</i>
        </span>
      </div>
      <div className="close-btn" onClick={() => onClose()}><CloseOutlined /></div>
    </div>
  );
}
